import i18next from 'i18next';

i18next.addResources('en', 'BottleMainInformation', {
  yourBottle: 'Your bottle',
  bottleTitle: 'of {{- title}}'
});

i18next.addResources('fr', 'BottleMainInformation', {
  yourBottle: 'Votre bouteille',
  bottleTitle: 'sur {{- title}}'
});

i18next.addResources('it', 'BottleMainInformation', {
  yourBottle: 'La tua bottiglia',
  bottleTitle: 'Di {{- title}}'
});

i18next.addResources('de', 'BottleMainInformation', {
  yourBottle: 'Ihre Flasche',
  bottleTitle: 'von {{- title}}'
});

i18next.addResources('zh', 'BottleMainInformation', {
  yourBottle: '瓶号',
  bottleTitle: '{{- title}}'
});

i18next.addResources('zt', 'BottleMainInformation', {
  yourBottle: '瓶號',
  bottleTitle: '{{- title}}'
});

i18next.addResources('es', 'BottleMainInformation', {
  yourBottle: 'Tu botella',
  bottleTitle: 'de {{- title}}'
});

i18next.addResources('pt', 'BottleMainInformation', {
  yourBottle: 'Sua garrafa',
  bottleTitle: 'de {{- title}}'
});

i18next.addResources('ja', 'BottleMainInformation', {
  yourBottle: 'あなたのボトル',
  bottleTitle: '{{- title}}の'
});

i18next.addResources('ru', 'BottleMainInformation', {
  yourBottle: 'Ваша бутылка',
  bottleTitle: '{{- title}}'
});

i18next.addResources('ar', 'BottleMainInformation', {
  yourBottle: 'زجاجتك',
  bottleTitle: 'من {{- title}}'
});

i18next.addResources('hi', 'BottleMainInformation', {
  yourBottle: 'आपकी बोतल',
  bottleTitle: '{{- title}} की'
});
